import React, {Component, Fragment} from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import './App.css';
import {identifyScreen, loadPackages} from '../utility';
import Spinner from './UI/Spinner/Spinner';
import PackagesList from './PackagesList/PackagesList';
import Package from './Package/Package';
import Product from './Product/Product';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      skreen: identifyScreen(200),
      packs: [],
      loadingPackages:true
    }
  }
  

  componentDidMount() {
    // console.log("app did mount");
    loadPackages(this.setState.bind(this));

  }

  render() {
    // console.log("app render");
    if(this.state.loadingPackages){
      return <Spinner />;
    }
    const {packs, skreen} = this.state;
    let output = null;
    
    if(this.state.skreen == "mobile") {
      output = (
        <Fragment>
          <Route path="/" exact render={(routeProps, additionalProps=this.state) => <PackagesList {...routeProps} {...additionalProps} /> } />
          <Route path="/package/:packageID" render={(routeProps, additionalProps=this.state) => <Package {...routeProps} {...additionalProps} /> } />
          <Route path="/product/:packageID/:productID" render={(routeProps, additionalProps=this.state) => <Product {...routeProps} {...additionalProps} /> } />
        </Fragment>
      );
    }
    else {
      output = <PackagesList packs={packs} skreen={skreen}/>
    }

    return <Router>{output}</Router>;
  }
}


window.onscroll=function(){
  let tooltips = document.getElementsByClassName('tooltip');
  this.setTimeout(function(){
    for(let i=0; i<tooltips.length; i++){
      tooltips[i].className = 'tooltip hover';
    }
    this.setTimeout(function(){
      for(let i=0; i<tooltips.length; i++){
        tooltips[i].className = 'tooltip';
      }
    }, 800);
  }, 0);
}


export default App;
